import { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Modal from 'react-responsive-modal'
import Swal from 'sweetalert2'

import Loader from '@shared/loader'
import StateStore from '@helpers/state-store'
import { fullName } from '@modules/form-wizard/utils'
import ApplicationNotes from '@modules/form-wizard/notes'

import BatchFormView from '../../../modules/form-wizard/form-batch-view'

import FullCalendar  from '@fullcalendar/react'
import DayGridPlugin from '@fullcalendar/daygrid'

import TimeGridPlugin from '@fullcalendar/timegrid'
import pha_clinics from '@constants/pha-clinics'

const PHA_SCHEDULER = {
  resource: '/pha_appointments',
  form_key: 'pha_appointment',
  path: 'pha-appointment-scheduling',
  label: 'Appointment Scheduling (PMH)',
  form_type: 'PhaAppointment',
  serviceType: record => {
    return 'Appointment Scheduling (PMH)'
  }
}

const CalendarView = props => {
  const endDateEvent = new Date();
  endDateEvent.setDate(endDateEvent.getDate() + 1)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [formSelected, setFormSelected] = useState(null)
  const [active, setActive] = useState({})
  const [showDateModal, setDateModal] = useState(false);
  const [startDate, setStartDate] = useState('')
  // const [clinic, setClinic] = useState('')
  const [endDate, setEndDate] = useState(endDateEvent.toISOString().split('T')[0])
  const [params, setParams] = StateStore({
    status: 'approved',
    page: 1,
    per_page: 30,
  })

  useEffect(() => {
    fetchRecords()
  }, [params.page])

  const fetchRecords = async () => {
    setLoading(true)

    try {
      const { data } = await $app.axios.get(PHA_SCHEDULER.resource, { params })

      setData(data.records)
      setParams(data.records_params)
      setLoading(false)
    } catch (err) {
      console.error(err)
    }
  }

  const clinicOptions = () => {
    const clinic_types = {}
    
    pha_clinics.forEach(x => {
      clinic_types[x.clinic_type] = x.clinic_type
    })
  
    console.log(clinic_types)
    
    return clinic_types
  }

  const filterClinic = async () => {
    const { value: facility } = await Swal.fire({
      icon: 'question',
      title: 'Search By Clinic',
      input: 'select',
      inputLabel: 'Which Clinic',
      inputOptions: clinicOptions(),
      showCancelButton: true,
      inputValidator: value => {
        if (!value) {
          return 'Please select a clinic'
        }
      },
    })

    if (!facility) return

    const currParams = params;
    currParams['clinic'] = facility;
    setParams(currParams);
    fetchRecords();
  }

  const filterDate = () => () => {
      const currParams = params;
      currParams['start_date'] = startDate;
      currParams['end_date'] = endDate;
      setParams(currParams);
      fetchRecords();

      return setDateModal(false);
  }

  const populateCalendar = () => {
    if (data.length > 0) {
      return data.map(x => ({ id: x.form_num,
                              title: fullName(x.user, true),
                              start: x.confirmed_appointment_date,
                              description: x.clinics,
                              confirmed_by: fullName(x.officer)	}))
    }
  }

  const writeNote = async record => {
    if (!record.notes?.length) record.notes = []

    const { value: text } = await Swal.fire({
      input: 'textarea',
      title: 'Add Note',
      inputAttributes: {
        autocorrect: 'on',
      },
      showCancelButton: true,
    })

    if (!text) return

    try {
      const { data } = await $app.axios.post('/services/notes/add_note', {
        note: {
          note_type: 'note',
          internal_view_only: true,
          notable_type: PHA_SCHEDULER.form_type,
          notable_id: record.id,
          text,
        },
      })

      record.notes.push(data.note)

      Swal.fire({
        icon: 'success',
        toast: 'true',
        text: 'Note successfully created',
        timer: 5000,
        position: 'top-end',
        showConfirmButton: false,
      })
    } catch (err) {
      console.error(err)
      
      Swal.fire({
        icon: 'error',
        toast: 'true',
        text: 'Failed to create note.',
        timer: 5000,
        position: 'top-end',
        showConfirmButton: false,
      })
    }
  }

  const allFields = [

  ]

  const dayHeaderFormat = {
    weekday: 'short',
  }

  const renderEventContent = (eventInfo) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column'}}>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
        <b>{eventInfo.event.extendedProps.description}</b>
        <span>{eventInfo.event.extendedProps.confirmed_by}</span>
      </div>
    )
  }

  return (
    <Fragment>
      <section className='content minister-applications-table'>
        <Loader loading={loading} />
        <article className='page-inner p-4'>
          <header className='flex justify-between items-center mb-6'>
            <h1 className='text-4xl text-gray-800'>
              Public Hospitals Authority (PHA)
            </h1>
            <nav className='flex justify-end space-x-4'>
              {/* <span
                onClick={() => setModal([MODAL.MODE])}
                className='flex space-x-1 items-center text-blue-700 cursor-pointer'
              >
                <i className='fas fa-ban'></i>
                <span>Cancel/Revoke</span>
              </span> */}
              <Link
                to='/logout'
                className='flex space-x-1 items-center text-blue-700'
              >
                <i className='fas fa-sign-out-alt'></i>
                <span>Sign Out</span>
              </Link>
            </nav>
          </header>
          <div className='card'>
            <div className='card-header flex flex-col xl:flex-row justify-between items-center'>
              <label className='flex items-center space-x-2'>
                <span className='font-semibold'>{PHA_SCHEDULER.label}</span>
              </label>
            </div>
            <div className='card-header flex flex-col xl:flex-row justify-between items-center'>
              <aside className='flex space-x-4 actions'>
                <span onClick={() => filterClinic()}>
                  Filter by Clinic
                </span>
              </aside>
            </div>
            <div className='card-body'>
              {!formSelected && (
                <div className='table-responsive form-records-table'>
                  <FullCalendar
                    plugins={[
                      DayGridPlugin,
                      TimeGridPlugin,
                    ]}
                    initialView='dayGridMonth'
                    headerToolbar={{
                      start: 'title',
                      center: '',
                      end: 'today prevYear,prev,next,nextYear'
                    }}
                    dayHeaderFormat={dayHeaderFormat}
                    weekends={true}
                    eventTimeFormat={{
                      hour: 'numeric',
                      minute: '2-digit',
                    }}
                    events={populateCalendar()}
                    eventContent={renderEventContent}
                  />
                </div>
              )}
              {formSelected && (
                <BatchFormView
                  passedProps={{service: PHA_SCHEDULER, formSelected}}
                  setFormSelected={setFormSelected}
                  methods={[{label: 'View Notes',fn: setActive}, {label: 'Write Note', fn: writeNote}]}
                  allFields={allFields}
                />
              )}
            </div>
          </div>
        </article>
        <ApplicationNotes
          data={active?.notes}
          onClose={() => setActive(null)}
        />
      </section>
      <Modal
        open={showDateModal}
        onClose={() => setDateModal(false)}
        center
      >
        <header className='modal-header'>
          <h4>Date Filter</h4>
        </header>
        <article className='modal-body flex flex-col space-y-6'>
          <div className='flex'>
            <label htmlFor="startDate">Start Date:</label>
            <input type="date" id="startDate" name="startDate" className='ml-2 rounded-sm' onChange={e => setStartDate(e.target.value)}/>
          </div>

          <div className='flex'>
            <label htmlFor="endDate">End Date:</label>
            <input type="date" id="endDate" name="endDate" className='ml-2 rounded-sm' onChange={e => setEndDate(e.target.value)}/>
          </div>
        </article>
        <footer className='modal-footer flex justify-end'>
          <button className='btn btn-muted' onClick={() => setDateModal(false)}>
            Close
          </button>
          <button className='btn btn-primary' onClick={filterDate()}>
            Filter
          </button>
        </footer>
      </Modal>
    </Fragment>
  )
}

export default CalendarView
